import React from 'react'
import './Service.css'
const Service = () => {
  return (
    <div>
        <section className="Services">
                <div className="first">
                    <h1 className="heading">Services We Provides</h1>
                    <p className="desc">We provides all digital solutions that your needs</p>
                    <div className="servicemenu">
                        <div className="item">
                            <img src="./images/webicon.png" alt="" />
                            <h1>Website Developement</h1>
                            <p>The Tech Query Provides all types of website development services like eCommerce, Static and
                                Dynamic, Personal, Portfolio, News/Media, Business, Educational, Government website and
                                more…</p>
                        </div>
                        <div className="item">
                            <img src="./images/icons8-marketing-96.png" alt="" />
                            <h1>App Developement</h1>
                            <p>The Tech Query Provides all types of website development services like eCommerce, Static and
                                Dynamic, Personal, Portfolio, News/Media, Business, Educational, Government website and
                                more…</p>
                        </div>
                        <div className="item">
                            <img src="./images/icons8-web-application-firewall-96.png" alt="" />
                            <h1>Software Developement</h1>
                            <p>The Tech Query Provides all types of website development services like eCommerce, Static and
                                Dynamic, Personal, Portfolio, News/Media, Business, Educational, Government website and
                                more…</p>
                        </div>
                    </div>
                    <a href='#contact'className="btn center">Contact us for more details</a>
                </div>
            </section>
            <section className="Technologi">
                <h1 className="heading">Technologies We Use</h1>
                <p className="desc">We use various type of technologies and integration in development according to clients need
                    or client’s choice</p>
                <div className="techitem">
                    <img src="./images/react-logo-ttq.svg" alt="" />
                    <img className='padding' src="./images/Bootstrap_logo.svg" alt="" />
                    <img src="./images/node-js-logo.svg" alt="" />
                    <img src="./images/php-logo.svg" alt="" />
                    <img src="./images/MongoDB_Logo.svg" alt="" />
                    <img className='padding' src="./images/JavaScript_logo.svg" alt="" />
                    <img src="./images/python-logo.svg" alt="" />
                    <img src="./images/next-js-logo.svg" alt="" />
                </div>
            </section>
    </div>
  )
}

export default Service